/**
* @author vishwadeep.kapoor
* HandlePayment
*
*/

import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { AppWrappperHOC } from '../Root/HOC';
import { selectHandlePayment } from './selectors';
import { utils, constants, eventTracking } from '../../devUtils';

class HandlePayment extends PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = { isSuccess: null, queryString: {} };
  }

  /**
   * @func react lifeCycle
   * @desc all conditions for the payment redirect response
   * @default isSuccess=false
   * @default queryString={}
   * @returns {setState}
   */
  componentWillMount() {
    const { history: { location: { pathname, search } = {} } } = this.props;
    const queryString = utils.parseQueryString(search);
    let isSuccess = false;
    if (pathname === constants.LINK_PAYU_FAIL) {
      isSuccess = false;
    } else if (pathname === constants.LINK_PAYU_SUCCESS) {
      isSuccess = true;
    } else if (pathname === constants.LINK_MOBIKWIK) {
      if (queryString.success === 'true') {
        isSuccess = true;
      }
    }
    eventTracking.triggerEvent('Gift Cards', 'Payment Completion', isSuccess ? 'Success' : 'Failure');
    this.setState({ isSuccess, queryString });
    // console.log('willMount.......', queryString, isSuccess, this.props);
  }

  render() {
    const { isSuccess, queryString } = this.state;
    // console.log(this.props);
    if (typeof (isSuccess) === 'boolean') {
      const _LINK_CONFIRM = constants.GET_LINK_CONFIRM('order', isSuccess);
      return <Redirect to={{ pathname: _LINK_CONFIRM, state: { isSuccess, queryString, preRoute: constants.LINK_MY_ORDERS } }} />;
    }
    return (
      <div>
        payment HandlePayment
      </div>
    );
  }
}

HandlePayment.propTypes = {
  dispatch: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
};

/**
 * @todo: need to remove the dependency from the store
 * @param {func} dispatch
 */
const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = createStructuredSelector({
  HandlePayment: selectHandlePayment(),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(HandlePayment));

export default {
  component,
};



// WEBPACK FOOTER //
// client/containers/HandlePayment/index.js